"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = exports.CloseIcon = exports.CloseButton = exports.Styles = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var icons_1 = require("../../icons");
var Arrow_styles_1 = __importDefault(require("./Arrow.styles"));
var Styles = styled_components_1.default.div.attrs({ role: 'tooltip' })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  padding: 15px;\n  min-height: 10px;\n  border-radius: 3px;\n  text-transform: none;\n  z-index: 1000;\n\n  color: ", ";\n  background-color: ", ";\n  width: ", "px;\n  height: ", "px;\n  top: ", "px;\n  left: ", "px;\n\n  ", ";\n  ", ";\n"], ["\n  position: absolute;\n  padding: 15px;\n  min-height: 10px;\n  border-radius: 3px;\n  text-transform: none;\n  z-index: 1000;\n\n  color: ", ";\n  background-color: ", ";\n  width: ", "px;\n  height: ", "px;\n  top: ", "px;\n  left: ", "px;\n\n  ", ";\n  ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.neutral.v100;
}, function (props) { return props.color || props.theme.color.primary.v600; }, function (_a) {
    var width = _a.width;
    return width;
}, function (_a) {
    var height = _a.height;
    return height;
}, function (_a) {
    var top = _a.top;
    return top;
}, function (_a) {
    var left = _a.left;
    return left;
}, function (_a) {
    var theme = _a.theme;
    return theme.font.detail.v200;
}, function (props) { return props.showArrow && Arrow_styles_1.default; });
exports.Styles = Styles;
var CloseButton = styled_components_1.default.button.attrs({
    name: 'close',
    type: 'button',
    'aria-label': 'close'
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  border: none;\n  background: none;\n  cursor: pointer;\n\n  &:hover {\n    opacity: 0.8;\n  }\n  &:active {\n    opacity: 0.54;\n  }\n  color: ", ";\n"], ["\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  border: none;\n  background: none;\n  cursor: pointer;\n\n  &:hover {\n    opacity: 0.8;\n  }\n  &:active {\n    opacity: 0.54;\n  }\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.neutral.v100;
});
exports.CloseButton = CloseButton;
var CloseIcon = styled_components_1.default(icons_1.Close).attrs({
    width: 12,
    height: 12
})(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
exports.CloseIcon = CloseIcon;
var Title = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding-bottom: 3px;\n  font-weight: ", ";\n  color: ", ";\n"], ["\n  padding-bottom: 3px;\n  font-weight: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.font.weight.v300;
}, function (_a) {
    var theme = _a.theme;
    return theme.color.neutral.v100;
});
exports.Title = Title;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
